import { Button } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

export const LoginButton = () => {
  return (
    <Button size='sm' colorPalette='brand' className='no-print' asChild>
      <NavLink to='/auth/login'>Login</NavLink>
    </Button>
  );
};
